<template>
  <div>
    <Drawer :title="migrateModalTitle" v-model="migrateModal" width="820" :mask-closable="true" @on-close="migrateModalCancel">
      <div>
        <Form ref="migrateForm" :model="migrateForm" :label-width="80" :rules="migrateRule">
          <FormItem label="源实例" prop="source_instance">
            <Select @on-change="getSourceDB" v-model="migrateForm.source_instance" clearable filterable>
              <Option v-for="item in instanceList" :value="item.id" :key="item.id" :label="item.name"></Option>
            </Select>
          </FormItem>
          <FormItem label="源数据库" prop="source_db">
            <Select @on-change="getTables" v-model="migrateForm.source_db" clearable filterable>
              <Option v-for="item in sourceDB" :value="item" :key="item" :label="item"></Option>
            </Select>
          </FormItem>
          <FormItem label="源数据表" prop="source_table">
            <transfer :data="tableList" :target-keys="migrateForm.source_table" :list-style="listStyle" @on-change="tableChange" filterable></transfer>
          </FormItem>
          <FormItem label="目标实例" prop="target_instance">
            <Select @on-change="getTargetDB" v-model="migrateForm.target_instance" clearable filterable>
              <Option v-for="item in instanceList" :value="item.id" :key="item.id" :label="item.name"></Option>
            </Select>
          </FormItem>
          <FormItem label="目标数据库" prop="target_db">
            <Select v-model="migrateForm.target_db" clearable filterable placeholder="默认新建数据库">
              <Option v-for="item in targetDB" :value="item" :key="item" :label="item"></Option>
            </Select>
          </FormItem>
          <FormItem label="克隆方式" prop="migrate_type">
            <RadioGroup v-model="migrateForm.migrate_type">
              <Radio :label="0">表结构</Radio>
              <Radio :label="1">表结构+数据</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="克隆选项" prop="migrate_option">
            <CheckboxGroup v-model="migrateForm.migrate_option">
              <Checkbox :label="0">视图</Checkbox>
              <Checkbox :label="1">存储过程</Checkbox>
              <Checkbox :label="2">定时事件</Checkbox>
              <Checkbox :label="3">克隆前是否备份</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="描述" prop="migrate_content">
            <Input v-model="migrateForm.migrate_content" :rows="2" type="textarea" placeholder="请输入说明" />
          </FormItem>
          <FormItem>
            <Button type="primary" @click="handleSubmit">提交</Button>
            <Button style="margin-left: 8px" @click="migrateModalCancel">取消</Button>
          </FormItem>
        </Form>
      </div>
    </Drawer>

    <Drawer v-model="detailModal" title="克隆数据详情" :mask-closable="true" @on-close="closeDetail" width="720">
      <p slot="header">
        <Icon type="ios-options"></Icon>
        <span>克隆数据详情</span>
      </p>
      <div>
        <CellGroup>
          <Cell title="操作人">
            <span slot="extra">{{detailData.applicant}}</span>
          </Cell>
          <Cell title="源实例" selected>
            <span slot="extra">{{detailData.source_instance}}</span>
          </Cell>
          <Cell title="源数据库" selected>
            <span slot="extra">{{detailData.source_db}}</span>
          </Cell>
          <Cell title="源数据表">
            <span slot="label">
              <pre style="white-space: pre-wrap; word-wrap: break-word; word-break: break-all;">{{detailData.source_tab}} </pre>
            </span>
          </Cell>
          <Cell title="目标实例" selected>
            <span slot="extra">{{detailData.target_instance}}</span>
          </Cell>
          <Cell title="目标数据库" selected>
            <span slot="extra">{{detailData.target_db}}</span>
          </Cell>
          <Cell title="新建数据库">
            <span slot="extra" v-if="detailData.is_new_db===1">
              <Badge count="YES" slot="extra" type="success" />
            </span>
            <span slot="extra" v-else>
              <Badge count="NO" slot="extra" type="error" />
            </span>
          </Cell>
          <Cell title="克隆数据">
            <span slot="extra" v-if="detailData.is_export_data===1">
              <Badge count="YES" slot="extra" type="success" />
            </span>
            <span slot="extra" v-else>
              <Badge count="NO" slot="extra" type="error" />
            </span>
          </Cell>
          <Cell title="克隆视图">
            <span slot="extra" v-if="detailData.is_export_view===1">
              <Badge count="YES" slot="extra" type="success" />
            </span>
            <span slot="extra" v-else>
              <Badge count="NO" slot="extra" type="error" />
            </span>
          </Cell>
          <Cell title="克隆存储过程/函数">
            <span slot="extra" v-if="detailData.is_export_routine===1">
              <Badge count="YES" slot="extra" type="success" />
            </span>
            <span slot="extra" v-else>
              <Badge count="NO" slot="extra" type="error" />
            </span>
          </Cell>
          <Cell title="克隆定时事件">
            <span slot="extra" v-if="detailData.is_export_event===1">
              <Badge count="YES" slot="extra" type="success" />
            </span>
            <span slot="extra" v-else>
              <Badge count="NO" slot="extra" type="error" />
            </span>
          </Cell>
          <Cell title="克隆前是否备份">
            <span slot="extra" v-if="detailData.is_export_target===1">
              <Badge count="YES" slot="extra" type="success" />
            </span>
            <span slot="extra" v-else>
              <Badge count="NO" slot="extra" type="error" />
            </span>
          </Cell>
          <Cell title="克隆数据说明">
            <span slot="label">
              <pre style="white-space: pre-wrap; word-wrap: break-word; word-break: break-all;">{{detailData.content}}
              </pre>
            </span>
          </Cell>
        </CellGroup>
      </div>
    </Drawer>

    <Drawer v-model="migrateLogModal" title="克隆数据日志" :mask-closable="true" width="720">
      <p slot="header" style="color:#f60;">
        <Icon type="ios-information-circle"></Icon>
        <span>克隆数据日志</span>
      </p>
      <div style="white-space: pre-line;">
        {{this.migrateLog}}
      </div>
      <div slot="footer">
        <Button type="primary" size="large" long @click="closeLog()">Close</Button>
      </div>
    </Drawer>

    <Card :style="{height: '100%', minHeight: '280px'}">
      <Row>
        <Button style="float: right;margin-bottom: 10px" type="primary" @click="addMigrate()">
          <Icon type="md-add" />新增</Button>
      </Row>
      <Row>
        <DatePicker style="float: right;margin-bottom: 10px" type="daterange" :value="dateValue" :options="dateOption" placement="bottom-end" placeholder="Select date" @on-change="getMigrate"></DatePicker>
      </Row>
      <tables ref="instanceTable" search-place="top" v-model="tableData" :columns="columns" />
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getMigrate"></page>
        </div>
      </Row>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getMigrateList, pushMigrate, showDatabaseList, getTableList, getInstanceList, getMigrateLog } from '@/api/mysql'

export default {
  name: 'MySQLMigrate',
  components: {
    Tables
  },
  data () {
    return {
      listStyle: {
        width: '324px',
        height: '300px'
      },
      // data migrate
      migrateModalTitle: '克隆数据',
      migrateModal: false,
      migrateForm: {
        source_instance: null,
        source_db: '',
        source_table: [],
        target_instance: null,
        target_db: '',
        migrate_type: null,
        migrate_option: [],
        migrate_content: ''
      },
      sourceDB: [],
      targetDB: [],
      tableList: [],
      migrateDetail: {},
      instanceList: [],
      migrateRule: {
        source_instance: [{ type: 'number', required: true, message: '请选择源实例', trigger: 'blur' }],
        source_db: [{ required: true, message: '请选择源数据库', trigger: 'blur' }],
        source_table: [{ type: 'array', required: true, message: '请选择源数据表', trigger: 'blur' }],
        target_instance: [{ type: 'number', required: true, message: '请选择目标实例', trigger: 'blur' }],
        migrate_type: [{ type: 'number', required: true, message: '请选择克隆方式', trigger: 'blur' }],
        migrate_content: [{ required: true, message: '请输入克隆数据的说明', trigger: 'blur' }]
      },
      count: 1,
      size: 15,
      page: 1,
      ordering: null,
      is_superuser: false,
      columns: [
        { title: 'ID', key: 'id', align: 'center', minWidth: 80 },
        {
          title: '发起人',
          key: 'applicant',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            return h('div', params.row.applicant.username)
          }
        },
        {
          title: '源实例',
          key: 'source_instance',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            return h('div', params.row.source_instance.name)
          }
        },
        { title: '源数据库', key: 'source_db', align: 'center', minWidth: 100 },
        { title: '源数据表', key: 'source_tab', tooltip: true, minWidth: 100 },
        {
          title: '目标实例',
          key: 'target_instance',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            return h('div', params.row.target_instance.name)
          }
        },
        { title: '目标数据库', key: 'target_db', align: 'center', minWidth: 100 },
        {
          title: '发起时间',
          key: 'create_time',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            return h('div', new Date(params.row.create_time).toLocaleString())
          }
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.showDetail(params)
                    }
                  }
                },
                [
                  h('div', '详情')
                ]
                ),
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  style: {
                    marginLeft: '5px'
                  },
                  on: {
                    click: () => {
                      this.showMigrateLog(params.row.id)
                    }
                  }
                },
                [
                  h('div', '日志')
                ]
                )

              ])
            }
          }
        }
      ],
      tableData: [],
      dateValue: [new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().slice(0, 10), new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().slice(0, 10)],
      dateOption: {
        shortcuts: [
          {
            text: '今天',
            value () {
              const start = new Date()
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              return [start, end]
            }
          },
          {
            text: '三天',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
              return [start, end]
            }
          },
          {
            text: '一周',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
              return [start, end]
            }
          },
          {
            text: '一个月',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
              return [start, end]
            }
          },
          {
            text: '三个月',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
              return [start, end]
            }
          }
        ]
      },

      // migrate log
      migrateLogModal: false,
      migrateLog: '',

      // detail info
      detailModal: false,
      detailData: {
        applicant: '',
        source_instance: '',
        source_db: '',
        source_tab: '',
        target_instance: '',
        target_db: '',
        is_new_db: '',
        is_export_data: '',
        is_export_view: '',
        is_export_routine: '',
        is_export_event: '',
        is_export_target: '',
        migrate_content: ''
      }
    }
  },

  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.query.id) {
        this.refresh()
      }
    }
  },
  methods: {
    getMigrate (value = 1) {
      if (typeof value === 'number') {
        this.page = value
      } else {
        this.dateValue = value
      }
      let params = {
        page: this.page,
        ordering: this.ordering,
        create_time__gt: this.dateValue[0],
        create_time__lt: this.dateValue[1]
      }
      getMigrateList(params).then(res => {
        this.tableData = res.data.results
        this.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取实例列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取实例列表失败！服务器无响应'
          })
        }
      })
    },

    handleSubmit () {
      this.$refs['migrateForm'].validate((valid) => {
        if (valid) {
          pushMigrate(this.migrateForm).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getMigrate()
            this.migrateModalCancel()
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },

    getSourceDB (value) {
      this.sourceDB = []
      this.migrateForm.source_db = ''
      if (value) {
        showDatabaseList({ id: value }).then(res => {
          this.sourceDB = res.data.results
        })
      }
    },

    getTargetDB (value) {
      this.targetDB = []
      this.migrateForm.target_db = ''
      if (value) {
        showDatabaseList({ id: value }).then(res => {
          this.targetDB = res.data.results
        })
      }
    },

    getTables () {
      let that = this
      that.tableList = []
      if (this.migrateForm.source_instance && this.migrateForm.source_db) {
        let data = {
          id: this.migrateForm.source_instance,
          db: this.migrateForm.source_db
        }
        getTableList(data).then(res => {
          if (res.status === 200) {
            let result = res.data.results
            for (let i in result) {
              that.tableList.push({
                key: result[i],
                label: result[i]
              })
            }
          }
        }).catch(res => {
          if (res.request) {
            this.$Notice.error({
              title: '操作失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '操作失败！服务器无响应'
            })
          }
        })
      }
    },

    migrateModalCancel () {
      this.migrateFormReset()
      this.migrateModal = false
    },

    migrateFormReset () {
      this.migrateForm.source_instance = null
      this.migrateForm.source_db = ''
      this.migrateForm.source_table = []
      this.migrateForm.target_instance = null
      this.migrateForm.target_db = ''
      this.migrateForm.migrate_type = null
      this.migrateForm.migrate_option = []
      this.migrateForm.migrate_content = ''
    },

    addMigrate () {
      this.getInstanceName()
      this.migrateModal = true
    },

    tableChange (newTargetKeys) {
      this.migrateForm.source_table = newTargetKeys
    },

    getInstanceName () {
      getInstanceList().then(res => {
        this.instanceList = res.data.results
      })
    },

    showMigrateLog (id) {
      let params = {
        migrate_id: id
      }
      getMigrateLog(params).then(res => {
        this.migrateLog = res.data.results[0].content
        this.migrateLogModal = true
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },

    closeLog () {
      this.migrateLogModal = false
    },

    closeDetail () {
      this.detailModal = false
    },

    showDetail (params) {
      this.detailData.applicant = params.row.applicant.username
      this.detailData.source_instance = params.row.source_instance.name
      this.detailData.target_instance = params.row.target_instance.name
      this.detailData.source_db = params.row.source_db
      this.detailData.source_tab = params.row.source_tab.replace(/,/g, '\n')
      this.detailData.target_db = params.row.target_db
      this.detailData.is_new_db = params.row.is_new_db
      this.detailData.is_export_data = params.row.is_export_data
      this.detailData.is_export_view = params.row.is_export_view
      this.detailData.is_export_routine = params.row.is_export_routine
      this.detailData.is_export_event = params.row.is_export_event
      this.detailData.is_export_target = params.row.is_export_target
      this.detailData.content = params.row.content
      this.detailModal = true
    }
  },

  mounted: function () {
    this.getMigrate()
  }
}
</script>
